import styled, { css } from "styled-components";
import { Button } from "@blueprintjs/core";

interface OptionalButtonProps {
  ishidden: boolean;
}

export const AddButton = styled(({ ...props }) => (
  <Button {...props} />
))<OptionalButtonProps>`
  margin: 1px;
  margin-top: 3px;
  margin-left: 3px;
  padding: 0;
  ${(props: OptionalButtonProps) =>
    props.ishidden &&
    css`
      opacity: 0;
      pointer-events: none;
    `}
`;
